export enum PortalWidgetType {
    WidgetStudentCalendarExamsAndTasks = 1,
    WidgetEvents = 2,
    WidgetArticlesAndNews = 3,
    WidgetAccountState = 4,
    WidgetAssignments = 5,
    WidgetMessages = 6,
    WidgetRequestsAndProcesses = 7,
    WidgetGrades = 8,
    WidgetSingleArticle = 9,
    WidgetStaffCalendar = 10,
    WidgetBookmarks = 11,
}